import React from 'react';
import { Form } from 'react-bootstrap';
import { FormAlerts, FormSubmitRow, ThemedSelect } from '../common';
import { useCreateUserForm } from './useCreateUserForm';
import { ROLE_OPTIONS } from './createUserFormUtils';

const CreateUsersForm = () => {
  const {
    formData,
    formError,
    formSuccess,
    submitting,
    handleChange,
    handleSubmit
  } = useCreateUserForm();

  return (
    <Form onSubmit={handleSubmit}>
      <FormAlerts error={formError} success={formSuccess} />
      <Form.Group className="mb-3">
        <Form.Label>Email <span className="text-danger">*</span></Form.Label>
        <Form.Control
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="Enter email"
          required
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Password <span className="text-danger">*</span></Form.Label>
        <Form.Control
          type="password"
          name="password"
          value={formData.password}
          onChange={handleChange}
          placeholder="Enter password"
          required
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Confirm password <span className="text-danger">*</span></Form.Label>
        <Form.Control
          type="password"
          name="confirmPassword"
          value={formData.confirmPassword}
          onChange={handleChange}
          placeholder="Confirm password"
          required
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>First name</Form.Label>
        <Form.Control
          type="text"
          name="first_name"
          value={formData.first_name}
          onChange={handleChange}
          placeholder="Enter first name"
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Last name</Form.Label>
        <Form.Control
          type="text"
          name="last_name"
          value={formData.last_name}
          onChange={handleChange}
          placeholder="Enter last name"
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Role <span className="text-danger">*</span></Form.Label>
        <ThemedSelect
          name="role"
          value={formData.role}
          options={ROLE_OPTIONS}
          onChange={handleChange}
          id="create-user-role-select"
        />
      </Form.Group>
      <FormSubmitRow
        isEditMode={false}
        submitting={submitting}
        createLabel="Create user"
      />
    </Form>
  );
};

export default CreateUsersForm;
